import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useLanguage } from '../context/LanguageContext'
import { useSubscription } from '../context/SubscriptionContext'

export default function PaymentResult() {
  const { t } = useLanguage()
  const { refreshSubscription } = useSubscription()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('order_id')

  const [status, setStatus] = useState('loading') // loading | success | failed
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (!orderId) {
      setStatus('failed')
      return
    }

    const interval = setInterval(async () => {
      setElapsed(prev => prev + 2)

      const { data } = await supabase
        .from('subscriptions')
        .select('status')
        .eq('order_id', orderId)
        .single()

      if (data?.status === 'active') {
        clearInterval(interval)
        setStatus('success')
        refreshSubscription()
        // Auto-redirect to dashboard after 3 seconds
        setTimeout(() => navigate('/dashboard'), 3000)
      } else if (data?.status === 'expired') {
        clearInterval(interval)
        setStatus('failed')
      }
    }, 2000)

    // Timeout after 30 seconds
    const timeout = setTimeout(() => {
      clearInterval(interval)
      setStatus(prev => prev === 'loading' ? 'failed' : prev)
    }, 30000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [orderId, navigate, refreshSubscription])

  return (
    <div className="app-layout">
      <div className="topbar">
        <div className="topbar-logo">
          <span style={{ color: '#E8610A', fontWeight: 900, fontSize: '1.1rem' }}>{t.appName} 🛡️</span>
        </div>
      </div>

      <div className="main-content">
        {status === 'loading' && (
          <div className="payment-result">
            <div className="scan-spinner" style={{ marginBottom: 24 }} />
            <div className="payment-result-title">{t.processingPayment}</div>
            <div className="payment-result-sub">{elapsed > 10 ? t.paymentFailedSub : ''}</div>
          </div>
        )}

        {status === 'success' && (
          <div className="payment-result">
            <div className="payment-result-icon">🎉</div>
            <div className="payment-result-title">{t.paymentSuccess}</div>
            <div className="payment-result-sub">{t.youArePremium}</div>
            <div style={{ color: 'var(--ash)', fontSize: '0.82rem' }}>{t.redirectingToDashboard}</div>
          </div>
        )}

        {status === 'failed' && (
          <div className="payment-result">
            <div className="payment-result-icon">😔</div>
            <div className="payment-result-title">{t.paymentFailed}</div>
            <div className="payment-result-sub">{t.paymentFailedSub}</div>
            <button className="btn-full" onClick={() => navigate('/pricing')} style={{ maxWidth: 300 }}>
              {t.tryAgain}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
